import { render, staticRenderFns } from "./xieyi.vue?vue&type=template&id=346eb3b6&scoped=true"
import script from "./xieyi.vue?vue&type=script&lang=js"
export * from "./xieyi.vue?vue&type=script&lang=js"
import style0 from "./xieyi.vue?vue&type=style&index=0&id=346eb3b6&prod&lang=scss"
import style1 from "./xieyi.vue?vue&type=style&index=1&id=346eb3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346eb3b6",
  null
  
)

export default component.exports